import { FieldProps, getIn } from 'formik';
import { PhoneInput } from '../inputs/PhoneInput/PhoneInput';

interface IPhoneFieldOwnProps extends FieldProps {
  id?: string;
  isAbleToCall?: boolean;
}

export const PhoneInputField = ({ field, form, ...props }: IPhoneFieldOwnProps) => {
  const error = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <PhoneInput
      {...field}
      {...props}
      id={props.id || field.name}
      error={touched && !!error}
      helperText={(touched && error) || ''}
    />
  );
};
